import React, {Component} from "react";
import {fabric} from "fabric";
import DrawPadItem from "./item";

class DrawPad extends Component {
    containerRef = null
    canvasRef = null
    canvas = null
    path = null
    points = []

    state = {
        canvas: null,
        scale: 0,
    }

    componentDidMount() {
        const {imageWidth, imageHeight, image, areas} = this.props
        const {clientWidth, clientHeight} = this.containerRef
        let canvasWidth = 0
        let canvasHeight = 0
        if (imageWidth / imageHeight > clientWidth / clientHeight) {
            canvasWidth = clientWidth
            canvasHeight = imageHeight / imageWidth * clientWidth
        } else {
            canvasHeight = clientHeight
            canvasWidth = imageWidth / imageHeight * clientHeight
        }
        let scale = canvasWidth / imageWidth
        this.canvas = new fabric.Canvas(this.canvasRef)
        this.canvas.fireRightClick = true
        this.canvas.stopContextMenu = true
        this.canvas.setWidth(canvasWidth)
        this.canvas.setHeight(canvasHeight)
        this.renderItem(areas, image, scale)

        this.canvas.on('mouse:up', this.handleMouseUp)

        this.setState({
            scale
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.areas !== this.props.areas) {
            this.renderItem(this.props.areas, this.props.image, this.state.scale)
        }
    }

    middleNumber = (items) => {
        return (Math.max(...items) - Math.min(...items)) / 2 + Math.min(...items)
    }

    renderItem(items, image, scale) {
        this.canvas.clear()
        this.path = null
        this.points = []
        fabric.Image.fromURL(image, (background) => {
            this.canvas.setBackgroundImage(background, this.canvas.renderAll.bind(this.canvas), {
                scaleX: this.canvas.width / background.width,
                scaleY: this.canvas.height / background.height,
            })
        })

        items.forEach(item => {
            const {points, fill} = item
            const pathString = "M " + points.map(i => `${i.x * scale} ${i.y * scale}`).join(" L ") + 'z'
            const path = new fabric.Path(pathString, {
                fill: fill, selectable: false
            })
            path.on('mousedblclick', () => this.handleItemClick(item))
            this.canvas.add(path)

            const centerX = this.middleNumber(points.map(i => i.x)) * scale
            const centerY1 = Math.min(...points.map(i => i.y)) * scale
            const centerY2 = Math.max(...points.map(i => i.y)) * scale

            if (item.title) {
                const title = new fabric.Text(item.title, {
                    fontSize: 22,
                    fontWeight: 30,
                    originX: 'center',
                    originY: 'top',
                    left: centerX,
                    top: centerY1 + 2,
                    fill: 'white', selectable: false
                })
                this.canvas.add(title)
            }
            if (item.description) {
                const description = new fabric.Text(item.description, {
                    fontSize: 16,
                    originX: 'center',
                    originY: 'bottom',
                    left: centerX,
                    top: centerY2 - 2,
                    fill: 'white', selectable: false
                })
                this.canvas.add(description)
            }
        })
    }

    handleMouseUp = async (event) => {
        const {readOnly = false} = this.props
        if (readOnly) return
        if (event.button === 1) {
            if (this.points.length === 0 && event.target) return
            const pointer = this.canvas.getPointer()
            this.points.push(pointer)
            if (this.path) {
                this.canvas.remove(this.path)
            }
            const path = "M " + this.points.map(item => `${item.x} ${item.y}`).join(" L ")
            this.path = new fabric.Path(path, {
                fill: 'rgba(0,0,0,0)',
                stroke: 'red',
                strokeWidth: 3,
                opacity: 0.5,
                selectable: false
            })
            this.canvas.add(this.path)
        } else {
            if (this.points.length <= 2) return
            this.path.set({fill: 'red'})
            this.canvas.renderAll()
            const points = this.points.map(item => ({
                x: item.x / this.state.scale,
                y: item.y / this.state.scale,
            }))
            await this.props.onAdd(points)
        }
    }

    handleItemClick = (item) => {
        const {readOnly = false} = this.props
        if (readOnly) return
        this.props.onItemClick(item)
    }

    render() {
        const {imageWidth, imageHeight, image, onAdd, onItemClick, style, ...otherProps} = this.props
        return (
            <div ref={ref => this.containerRef = ref}
                 style={{...style, display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                 {...otherProps}>
                <canvas ref={ref => this.canvasRef = ref}/>
            </div>
        );
    }
}

DrawPad.Item = DrawPadItem

export default DrawPad